import { Component, OnInit, AfterViewInit, ViewChild, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'loanadvance',
    templateUrl: './loanadvance.component.html',
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
            state('expanded', style({ height: '*', visibility: 'visible' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class LoanAdvanceComponent implements OnInit, AfterViewInit {

    @Input() loanAdvanceData: any;
    displayedColumns = ['action', 'institution', 'clientAcctNumber', 'creditLineLimit', 'availableCredit', 'currentBalance'];
    dataSource: MatTableDataSource<Element>;
    @ViewChild('MatPaginator', { static: false }) paginator: MatPaginator;
    @ViewChild('sort', { static: false }) sort: MatSort;
    expandedElement: any;
    lowValue: number = 0;
    highValue: number = 20;
    constructor(
        private translationService: PershingTranslationService
    ) {
        this.dataSource = new MatTableDataSource();
    }

    ngOnInit() {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
    }

ngAfterViewInit(): void {
    this.dataSource = this.loanAdvanceData;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
}

goToLoanAdvance(acctNumber: any) {
    document.dispatchEvent(new CustomEvent('portal.gotoview', {
        detail: {
            'gotoPage': '/nxi/portfolio/balances',
            'gotoParams': {'nplFlag' : true},
            'context': { 'domain': 'account', 'value': acctNumber }
        }
    }));
}
  public getPaginatorData(event: PageEvent): PageEvent {
    this.lowValue = event.pageIndex * event.pageSize;
    this.highValue = this.lowValue + event.pageSize;
    return event;
}
}
